/* eslint-disable @typescript-eslint/no-unused-vars */
import "./styles/ModalStyle.scss";
import { Modal } from "react-bootstrap";
import React, { ReactNode } from "react";
import { ModalProps, PATH } from "./UserModalController";
import { DynamicModalContent } from "../../contenful/types";
import { useSelector } from "react-redux";
import { AppState } from "../../RootReducer";
import { getPathType, hasContent, isHomeScreen } from "./utils";

interface Props extends ModalProps {
  children: ReactNode | ReactNode[];
}


/**
 * Bootstrap Modal component to be called here, to enable switching between forms without modal animation.
 * Provides props to all children. ( simplify the process of prop drilling )
 * @param Props
 */
const ModalRoute = ({ children, ...rest }: Partial<Props>) => {
  const { location, content, journey } = rest;
  const settings = useSelector((app: AppState) => app.settings);
  

  if (!children) return null; 

  function childrenWithProps() {
    return React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { ...rest });
      }
    });
  }

  const modalclass = location && getPathType(location?.search as string);
  const isMobile = settings && settings.mobile;
  const onboarding = content && content?.onboardingpage?.dynamicContent
  const homeScreen = isHomeScreen();

  const setClassnameBasedOnContent = () => {
    let classname = ""
    if(location){
      if(getPathType(location?.search) === PATH.LOGIN && !homeScreen){
        if(hasContent(onboarding as DynamicModalContent[], PATH.LOGIN)){
          classname = "content"
        }
      }
      if(getPathType(location?.search) === PATH.REGISTRATION && !homeScreen){
        if(hasContent(onboarding as DynamicModalContent[], PATH.REGISTRATION)){
          classname = "content"
        }
      }
    }
    return classname
  } 

  return (
    <div className={`${!homeScreen ? "modal-root" : null}`}>
      <Modal size="lg" dialogClassName={`user-modal ${modalclass}-modal ${!isMobile ? "desktop" : "mobile"} ${setClassnameBasedOnContent()}`} centered show={true}>
        {childrenWithProps()}
      </Modal>
    </div>
  );
};

export default ModalRoute;


/* style={{overflow: isMobile ? "" : "hidden"}}  */